import { render, staticRenderFns } from "./BackTop.vue?vue&type=template&id=c59e85a4"
import script from "./BackTop.vue?vue&type=script&lang=js"
export * from "./BackTop.vue?vue&type=script&lang=js"
import style0 from "./BackTop.vue?vue&type=style&index=0&id=c59e85a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports